import { MarketplaceIds } from './marketplace-ids';

export const AmzMarketplaceIds = [
  MarketplaceIds.Amazon,
  MarketplaceIds.AmazonUK,
  MarketplaceIds.AmazonCA,
  MarketplaceIds.AmazonDE,
  MarketplaceIds.AmazonES,
  MarketplaceIds.AmazonFR,
  MarketplaceIds.AmazonIT,
  MarketplaceIds.AmazonJP,
  MarketplaceIds.AmazonMX,
  MarketplaceIds.AmazonAU,
];
